module.exports = __webpack_public_path__ + "static/downloads/User_documentation_-_Excel_to_ecoSpold2_Web_Converter_v1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/User_documentation_-_Excel_to_ecoSpold2_Web_Converter_v1.pdf
// module id = ZweM
// module chunks = 1